import Question from '../api/question';
import { applicationSave, applicationDestroy } from './applicationActions';

export const saveQuestion = applicationSave(Question);
export const destroyQuestion = applicationDestroy(Question);
